import { EyeNoneIcon, EyeOpenIcon } from '@radix-ui/react-icons'
import { useKestrel } from 'features/kestrelViewer'
import React, { FC } from 'react'
import styled from 'styled-components'
import { KVPlaneIntersection } from 'types'

const PLANE_INTERSECTION_VISIBLE_FIELD = 'planeIntersectionVisible'

const StyledEyeClosedIcon = styled(EyeNoneIcon)`
  color: lightgray;
  &:hover {
    color: white;
  }
`

const StyledEyeOpenIcon = styled(EyeOpenIcon)`
  color: lightgray;
  &:hover {
    color: white;
  }
`

export const TogglePlaneIntersectionVisibilityButton: FC<{
  planeIntersection: KVPlaneIntersection
}> = ({ planeIntersection }) => {
  const { updatePlaneIntersection } = useKestrel()

  const togglePlaneIntersectionVisibility = (e: React.MouseEvent) => {
    e.stopPropagation()
    const isVisible = planeIntersection.planeIntersectionVisible
    if (updatePlaneIntersection)
      updatePlaneIntersection(
        planeIntersection,
        PLANE_INTERSECTION_VISIBLE_FIELD,
        (a: KVPlaneIntersection) => {
          a.planeIntersectionVisible = !isVisible
          return a
        },
        !isVisible
      )
  }

  return (
    <div
      style={{ cursor: 'pointer' }}
      onClick={(e) => togglePlaneIntersectionVisibility(e)}>
      {planeIntersection.planeIntersectionVisible ? (
        <StyledEyeOpenIcon width={22} height={22} />
      ) : (
        <StyledEyeClosedIcon width={22} height={22} />
      )}
    </div>
  )
}
